import React, { Component } from "react";

import { connect } from "react-redux";
import {
  getUsersDevices,
  deleteDevices,
  getInactiveUsers,
  deleteInactiveUsers
} from "../actions/usersDevicesActions";

import { getDevices } from "../actions/deviceActions";
import { getUsersLogs } from "../actions/usersLogsActions";

import PropTypes from "prop-types";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup
} from "reactstrap";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";

export class UsersDevices extends Component {
  state = {
    selected: [],
    modal: false
  };

  componentDidMount() {
    this.props.getUsersDevices();
    this.props.getInactiveUsers();
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    });
  };

  onSubmit = (e, users) => {
    e.preventDefault();

    this.toggle();
    this.props.deleteInactiveUsers(users);
  };

  handleBtnClick = ids => {
    this.props.deleteDevices(ids);
    this.props.getDevices(this.props.auth.user[0].username);
    this.props.getUsersLogs();
  };

  handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      this.setState(() => ({
        selected: [...this.state.selected, row.deviceId]
      }));
    } else {
      this.setState(() => ({
        selected: this.state.selected.filter(x => x !== row.deviceId)
      }));
    }
  };

  handleOnSelectAll = (isSelect, rows) => {
    let ids = rows.map(a => a.deviceId);

    if (isSelect) {
      this.setState(() => ({
        selected: ids
      }));
    } else {
      this.setState(() => ({
        selected: []
      }));
    }
  };

  render() {
    const { devices, users } = this.props.device;
    const columns = [
      {
        dataField: "username",
        text: "Username",
        filter: textFilter()
      },
      {
        dataField: "userType",
        text: "User Type"
      },
      {
        dataField: "deviceName",
        text: "Device Name"
      },
      {
        dataField: "registrationTime",
        text: "Time Created"
      },
      {
        dataField: "deviceMAC",
        text: "MAC Address",
        filter: textFilter()
      },
      {
        dataField: "userPassword",
        text: "Password"
      }
    ];

    const selectRow = {
      mode: "checkbox",
      clickToSelect: true,
      onSelect: this.handleOnSelect,
      onSelectAll: this.handleOnSelectAll
    };

    let button = (
      <div>
        {users.username && users.username.length > 0 ? (
          <Button
            color="primary"
            style={{ margin: "0.4rem" }}
            onClick={this.toggle}>
            Delete non active students
          </Button>
        ) : null}
      </div>
    );

    return (
      <div>
        <div className="d-flex flex-row  mb-3">
          <div className="p-2 bd-highlight">
            {" "}
            <Button
              color="danger"
              style={{ margin: "0.4rem" }}
              onClick={() => this.handleBtnClick(this.state.selected)}>
              Delete
            </Button>
          </div>
          <div className="p-2 bd-highlight">{button}</div>
        </div>

        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>
            {" "}
            Inactive Users Delete Confirmation{" "}
          </ModalHeader>
          <ModalBody>
            <Form
              onSubmit={e => {
                this.onSubmit(e, users.username);
              }}>
              <FormGroup>
                Are you sure you want to delete {users.inactive} users?
                <Button color="danger" style={{ marginTop: "2rem" }} block>
                  Delete Users
                </Button>
              </FormGroup>
            </Form>
          </ModalBody>
        </Modal>

        <BootstrapTable
          wrapperClasses="table-responsive ml-3"
          keyField="deviceId"
          data={devices}
          columns={columns}
          selectRow={selectRow}
          pagination={paginationFactory()}
          filter={filterFactory()}
        />
      </div>
    );
  }
}

UsersDevices.propTypes = {
  getUsersDevices: PropTypes.func.isRequired,
  device: PropTypes.object.isRequired,
  getInactiveUsers: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  device: state.usersDevices,
  auth: state.auth
});

export default connect(mapStateToProps, {
  getUsersDevices,
  deleteDevices,
  getInactiveUsers,
  deleteInactiveUsers,
  getDevices,
  getUsersLogs
})(UsersDevices);
